import { render, staticRenderFns } from "./HFriend.vue?vue&type=template&id=11b8f122&scoped=true&"
import script from "./HFriend.vue?vue&type=script&lang=js&"
export * from "./HFriend.vue?vue&type=script&lang=js&"
import style0 from "./HFriend.vue?vue&type=style&index=0&id=11b8f122&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b8f122",
  null
  
)

export default component.exports